import React, { FC } from 'react';
import styled from 'styled-components';
import { Media } from 'vendor/mods/media-breakpoints-fresnel/components/Media';
import { ProductsSectionItem } from 'src/modules/products/components/ProductsSectionItems/ProductsSectionItem';
import { media } from 'src/styles/designs';
import { ProductSectionItemsSwiper } from 'src/modules/products/components/ProductsSectionItems/ProductsSectionItemsSwiper';
import { BaseProductDTO } from 'src/models/pim';

const ProductsContainer = styled.div<{ $noOfColumns: number }>`
  display: grid;
  grid-template-columns: ${({ $noOfColumns }) => 'auto '.repeat($noOfColumns)};
  grid-row-gap: 104px;
  grid-column-gap: 70px;
`;

const Container = styled.div`
  margin-top: 50px;

  ${media.w.greaterThanOrEqual.desktop} {
    margin-top: 104px;
  }
`;

interface ProductsSectionItemsProps {
  products: BaseProductDTO[];
  noOfColumns?: number;
}

export const ProductsSectionItems: FC<ProductsSectionItemsProps> = ({
  products,
  noOfColumns = 3,
}) => {
  return (
    <Container>
      <Media greaterThanOrEqual="desktop">
        <ProductsContainer $noOfColumns={noOfColumns}>
          {products.map((product) => (
            <ProductsSectionItem key={product.code} product={product} />
          ))}
        </ProductsContainer>
      </Media>
      <Media lessThan="desktop">
        <ProductSectionItemsSwiper products={products} />
      </Media>
    </Container>
  );
};
